import * as React from 'react';
import { BRAND_TERRACOTTA, SYMBOL_ASPECT, SYMBOL_PATHS, SYMBOL_VIEWBOX } from './brand-art';

/**
 * BuilderSiteNow brand symbol — the folded-"B" mark.
 *
 * Plain inline SVG (no MUI, no hooks) so it is safe in both Server and Client
 * Components and never trips the RSC cloneElement icon-dropping issue. Recolour
 * via `color`; `size` is the rendered height in px (width derives from the
 * mark's aspect ratio).
 *
 * Single source of truth for the brand mark — replaces the per-file "B" badge
 * functions that previously lived in login/page.tsx and MarketingShell.tsx.
 */
export function BrandSymbol({
  size = 32,
  color = BRAND_TERRACOTTA,
  title = 'BuilderSiteNow',
  ...rest
}: {
  size?: number;
  color?: string;
  title?: string;
} & Omit<React.SVGProps<SVGSVGElement>, 'color' | 'width' | 'height'>) {
  return (
    <svg
      width={Math.round(size * SYMBOL_ASPECT)}
      height={size}
      viewBox={SYMBOL_VIEWBOX}
      fill={color}
      role="img"
      aria-label={title}
      {...rest}
    >
      {SYMBOL_PATHS.map((d, i) => (
        <path key={i} d={d} />
      ))}
    </svg>
  );
}

export default BrandSymbol;
